import { render, staticRenderFns } from "./AlertDelete.vue?vue&type=template&id=c46e87d2&"
import script from "./AlertDelete.vue?vue&type=script&lang=ts&"
export * from "./AlertDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports